module.exports = __webpack_public_path__ + "images/9e4493bfe587ca74ebc094b1c5527fa4-01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/01.jpg
// module id = ./src/assets/images/slides/living/01.jpg
// module chunks = 0